import {
  CARD_PURCHASE_LOOKUP,
  CHANGE_PASSWORD_CONFIRMATION,
  HOURLY_SCHEDULE,
  NEWSLETTER_CONFIRMATION,
  NEWSLETTER_FORM_RESIGN,
  NEWSLETTER_FORM_WIDGET,
  REGISTER_B2B,
} from "../../../app/routes";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const navbarHiddenRoutes = [
    HOURLY_SCHEDULE,
    NEWSLETTER_FORM_WIDGET,
    NEWSLETTER_CONFIRMATION,
    NEWSLETTER_FORM_RESIGN,
    CHANGE_PASSWORD_CONFIRMATION,
    REGISTER_B2B,
    CARD_PURCHASE_LOOKUP,
  ];

  const showNavBar = () => {
    if (navbarHiddenRoutes.includes(window.location.pathname)) {
      return false;
    } else {
      return true;
    }
  };

  return showNavBar();
};
